// extracted by mini-css-extract-plugin
module.exports = {"searchIcon":"InputSearch_searchIcon__353mR"};